import { createFileRoute } from '@tanstack/react-router';

import { QuoteRequestTemplateCreatePage } from '@/areas/quote-requests/QuoteRequestTemplates/QuoteRequestTemplateCreatePage';
import { canManageSourcingTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/templates/quote-request/create')({
    staticData: { access: { permissions: canManageSourcingTemplates }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <QuoteRequestTemplateCreatePage />;
}
